import { render, staticRenderFns } from "./FreeshippingInfo.vue?vue&type=template&id=661a029e&scoped=true"
import script from "./FreeshippingInfo.vue?vue&type=script&lang=js"
export * from "./FreeshippingInfo.vue?vue&type=script&lang=js"
import style0 from "./FreeshippingInfo.vue?vue&type=style&index=0&id=661a029e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661a029e",
  null
  
)

export default component.exports